// redux
import { useDispatch } from 'react-redux'
import {
	openPopuptop,
	toggleSlideMenu,
	openModal,
	closeModal,
	showLoading,
	hidePopuptop,
	setInstallPrompt,
	setControllerBack,
	resetControllerBack,
	toggleMenu,
	openOverlay,
	closeOverlay,
	handledNavBar,
	handleShowIconCloseModal
} from '../state/actions/ElementsUIActions'

export default function useUIActions() {
	const dispatch = useDispatch()

	const handleShowModal = modal => dispatch(openModal({ modalActive: modal }))
	const handleCloseModal = () => dispatch(closeModal())
	const handleShowPopupTop = popup => dispatch(openPopuptop({ popupTopActive: popup }))
	const handleHidePopuptop = () => dispatch(hidePopuptop())
	const handleToggleSlideMenu = () => dispatch(toggleSlideMenu())
	const handleLoading = loading => dispatch(showLoading({ showLoading: loading }))
	const initSetInstallPrompt = installPrompt => dispatch(setInstallPrompt({ installPrompt }))
	const handleShowCloseIconModal = value => dispatch(handleShowIconCloseModal({ value }))

	// overlay control
	const showOverlay = overlay => dispatch(openOverlay({ showOverlay: overlay }))
	const hideOverlay = () => dispatch(closeOverlay())

	// hide menu
	const handledToggleMenu = boolean => dispatch(toggleMenu({ hideMenu: boolean }))

	// hide nav bar
	const handledNavBarControl = boolean => dispatch(handledNavBar({ hideNavBar: boolean }))

	// control head button back
	// Note: remember use controlBack: true and reset the control
	const handleSetControlBack = prop => dispatch(setControllerBack({ controllerBack: prop }))
	const handleResetControlBack = () => dispatch(resetControllerBack({}))

	return {
		handleShowPopupTop,
		handleHidePopuptop,
		handleToggleSlideMenu,
		handleShowModal,
		handleCloseModal,
		handleLoading,
		initSetInstallPrompt,
		handleSetControlBack,
		handleResetControlBack,
		handleShowCloseIconModal,
		handledToggleMenu,
		showOverlay,
		hideOverlay,
		handledNavBarControl
	}
}
